import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatformHeaderComponent } from './shared/platform-header/platform-header.component';
import { DynamicModule } from 'ng-dynamic-component';
import { PlatformMenuComponent } from './shared/platform-menu/platform-menu.component';
import { PlatformSubHeaderComponent } from './shared/platform-sub-header/platform-sub-header.component';
import { PlatformMainContentComponent } from './shared/platform-main-content/platform-main-content.component';
import {
  DropDownComponent,
  DropDownOption,
} from './shared/elements/drop-down/drop-down.component';
import { DropDownListItemComponent } from './shared/elements/drop-down/drop-down-list-item/drop-down-list-item.component';
import { RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { ButtonComponent } from './shared/elements/button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PlatformFooterComponent } from './shared/platform-footer/platform-footer.component';
import { PlatformBottomComponent } from './shared/platform-bottom/platform-bottom.component';
import { LinkResolverDirective } from './shared/directives/link-resolver.directive';
import { HeadlineTagComponent } from './shared/elements/headline-tag/headline-tag.component';
import { StatusLabelComponent } from './shared/elements/status-label/status-label.component';
import { PaginationComponent } from './shared/elements/pagination/pagination.component';
import { CheckboxComponent } from './shared/elements/checkbox/checkbox.component';
import { AlertDialogComponent } from './shared/dialogs/alert-dialog/alert-dialog.component';
import { WarningBannerComponent } from './shared/elements/warning-banner/warning-banner.component';
import { FullWidthToastComponent } from './shared/toasts/full-width-toast/full-width-toast.component';
import { ImageCarouselComponent } from './shared/elements/image-carousel/image-carousel.component';
import { LinkComponent } from './shared/elements/link/link.component';
import { ToastService } from './shared/services/toast.service';
import { PriceComponent } from './shared/elements/price/price.component';
import { IconBarComponent } from './shared/elements/icon-bar/icon-bar.component';
import { PlatformSubFooterComponent } from './shared/platform-sub-footer/platform-sub-footer.component';
import { NotFoundComponent } from './shared/components/errors/not-found/not-found.component';
import { AccordionComponent } from './shared/elements/accordion/accordion.component';
import { AccordionListItemComponent } from './shared/elements/accordion/accordion-list-item/accordion-list-item.component';
import { QuantitySelectorComponent } from './shared/elements/quantity-selector/quantity-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { LabelButtonComponent } from './shared/elements/label-button/label-button.component';
import { AddressFormComponent } from './shared/forms/address-form/address-form.component';
import { TitleBarComponent } from './shared/elements/title-bar/title-bar.component';
import {
  FilterChipsComponent,
  FilterChip,
} from './shared/elements/filter-chips/filter-chips.component';
import { SearchBoxComponent } from './shared/elements/search-box/search-box.component';
import { FilterChipListItemComponent } from './shared/elements/filter-chips/filter-chip-list-item/filter-chip-list-item.component';
import { RadioComponent } from './shared/elements/radio/radio.component';
import { BasePathConfig } from './shared/config/basePath.config';
import { SignUpShopComponent } from './shared/forms/sign-up-shop/sign-up-shop.component';
import { InputComponent } from './shared/forms/elements/input/input.component';
import { SelectComponent } from './shared/forms/elements/select/select.component';
import { ShopContactFormComponent } from './shared/forms/shop-contact-form/shop-contact-form.component';
import { TextAreaComponent } from './shared/forms/elements/text-area/text-area.component';
import { SwiperModule } from 'swiper/angular';
import { YoutubeComponent } from './shared/elements/youtube/youtube.component';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { MsalAuthComponent } from './shared/components/msal-auth/msal-auth.component';
import { SidebarComponent } from './shared/elements/sidebar/sidebar.component';
import { MarkdownComponent } from './shared/elements/markdown/markdown.component';
import { BrandLogoComponent } from './shared/brand-logo/brand-logo.component';

export { DropDownOption, FilterChip };

@NgModule({
  imports: [
    CommonModule,
    DynamicModule,
    RouterModule,
    MarkdownModule,
    TranslateModule,
    LazyLoadImageModule,
    ReactiveFormsModule,
    SwiperModule,
    YouTubePlayerModule,
  ],
  declarations: [
    PlatformHeaderComponent,
    PlatformMenuComponent,
    PlatformSubHeaderComponent,
    PlatformMainContentComponent,
    DropDownComponent,
    DropDownListItemComponent,
    ButtonComponent,
    PlatformFooterComponent,
    PlatformBottomComponent,
    LinkResolverDirective,
    HeadlineTagComponent,
    StatusLabelComponent,
    PaginationComponent,
    CheckboxComponent,
    AlertDialogComponent,
    WarningBannerComponent,
    FullWidthToastComponent,
    ImageCarouselComponent,
    LinkComponent,
    PriceComponent,
    IconBarComponent,
    PlatformSubFooterComponent,
    NotFoundComponent,
    AccordionComponent,
    AccordionListItemComponent,
    QuantitySelectorComponent,
    LabelButtonComponent,
    AddressFormComponent,
    TitleBarComponent,
    FilterChipsComponent,
    FilterChipListItemComponent,
    SearchBoxComponent,
    RadioComponent,
    SignUpShopComponent,
    InputComponent,
    SelectComponent,
    ShopContactFormComponent,
    TextAreaComponent,
    YoutubeComponent,
    MsalAuthComponent,
    SidebarComponent,
    MarkdownComponent,
    BrandLogoComponent,
  ],
  exports: [
    PlatformHeaderComponent,
    PlatformMenuComponent,
    PlatformMainContentComponent,
    PlatformSubHeaderComponent,
    PlatformBottomComponent,
    PlatformFooterComponent,
    ButtonComponent,
    FullWidthToastComponent,
    WarningBannerComponent,
    CheckboxComponent,
    DropDownComponent,
    StatusLabelComponent,
    LinkResolverDirective,
    ImageCarouselComponent,
    PaginationComponent,
    HeadlineTagComponent,
    LinkComponent,
    PriceComponent,
    IconBarComponent,
    PlatformSubFooterComponent,
    NotFoundComponent,
    AccordionComponent,
    QuantitySelectorComponent,
    LabelButtonComponent,
    AddressFormComponent,
    TitleBarComponent,
    FilterChipsComponent,
    SearchBoxComponent,
    RadioComponent,
    SignUpShopComponent,
    ShopContactFormComponent,
    InputComponent,
    SelectComponent,
    YoutubeComponent,
    MsalAuthComponent,
    TextAreaComponent,
    SidebarComponent,
    MarkdownComponent,
    BrandLogoComponent,
  ],
  providers: [ToastService],
  entryComponents: [FullWidthToastComponent],
})
export class UiModule {
  static forRoot(
    basePathConfig: BasePathConfig = {}
  ): ModuleWithProviders<UiModule> {
    return {
      ngModule: UiModule,
      providers: [{ provide: BasePathConfig, useValue: basePathConfig || {} }],
    };
  }
}
